export class ExtractRequest {
    public assignorGuid: string;
    public startDate: Date = null;
    public endDate: Date = null;
    public datePeriod: number;
    public limit: number;
    public offset: number;
    public tip: number;
    public details: boolean = false;
    public products: number[] = [0]
    public collaborators: number[] = [0]
    public status: string
}

export class ExtractConsumerRequest {
    accountArray: string[];
    accountGuid: string;
    details: boolean;
    finalDate: Date;
    initialDate: Date;
    launchType: number;
    limit: number;
    offset: number;
    personGuid: string;
    rangeDays: number;
    tip:any;
}
